import React from 'react';
import { Box, Avatar, ButtonBase } from '@mui/material';
import { apiBaseUrl } from '../utils/Api/Api';
import Pets from '@mui/icons-material/Pets';
import EditIcon from '@mui/icons-material/Edit';
import { compressImageFile } from '../utils/compressImage';

const AvatarUploader = ({ pet, handleAvatarChange, onAvatarError }) => {
  const handleImageChange = async (event) => {
    const input = event.target;
    const file = input.files?.[0];
    if (!file) return;

    try {
      const dataUrl = await compressImageFile(file);
      await handleAvatarChange(dataUrl);
    } catch (error) {
      console.error('Avatar upload failed:', error);
      onAvatarError?.(error);
    } finally {
      // Allow selecting the same file again
      input.value = '';
    }
  };

  return (
    <Box sx={{ display: 'inline-block', position: 'relative' }}>
      <Avatar
        src={pet.avatar_url ? `${apiBaseUrl}${pet.avatar_url}` : undefined}
        alt={pet.name}
        sx={{ width: 120, height: 120 }}
      >
        <Pets/>
      </Avatar>
      <ButtonBase
        variant="outlined"
        component="label"
        sx={{
          width: '32px', height: '32px', borderRadius: '50%', bgcolor: '#263238', color: 'white',
          display: 'flex', position: 'absolute', bottom: 0, right: 1, p: 1}}>
        <EditIcon sx={{ width: '16px', height: '16px' }} />
        <input
          type="file"
          accept="image/*"
          hidden
          onChange={handleImageChange}
        />
      </ButtonBase>
    </Box>
  );
};

export default AvatarUploader;
